module.exports = __webpack_public_path__ + "img/logo.b47bcb16.jpg";